var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showOrders,
            expression: "showOrders",
          },
        ],
      },
      [
        _vm.ordersSummary.total_price
          ? _c("div", { staticClass: "show_small tr-highlighted p-1 mb-4" }, [
              _c("p", [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      (_vm.ordersSummary.total_price &&
                        _vm.ordersSummary.total_price.toLocaleString(
                          "ru-RU"
                        )) ||
                        0
                    )
                  ),
                ]),
                _vm._v("\n        сумма\n      "),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      (_vm.ordersSummary.total_salary &&
                        _vm.ordersSummary.total_salary.toLocaleString(
                          "ru-RU"
                        )) ||
                        0
                    )
                  ),
                ]),
                _vm._v("\n        ЗП\n      "),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      (_vm.ordersSummary.total_post &&
                        _vm.ordersSummary.total_post.toLocaleString("ru-RU")) ||
                        0
                    )
                  ),
                ]),
                _vm._v("\n        почтовые р.\n      "),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      (_vm.ordersSummary.total_pass &&
                        _vm.ordersSummary.total_pass.toLocaleString("ru-RU")) ||
                        0
                    )
                  ),
                ]),
                _vm._v("\n        к сдаче\n      "),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.orders.length
          ? _c("table", { staticClass: "table table-sm table-hover" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("Номер")]),
                  _vm._v(" "),
                  !_vm.clearedView
                    ? _c("th", [
                        _vm._v("Проект"),
                        _c("br"),
                        _vm._v("Бандероль"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.clearedView ? _c("th", [_vm._v("Препараты")]) : _vm._e(),
                  _vm._v(" "),
                  _c("th", { staticClass: "minW-85" }, [_vm._v("Сумма")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("З/п")]),
                  _vm._v(" "),
                  !_vm.clearedView
                    ? _c("th", [_vm._v("Почтовы р.")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _vm.cashOperate
                    ? _c("th", [_vm._v("К сдаче нал.")])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.clearedView && _vm.showOrdersCostPrice
                    ? _c("th", [_vm._v("EUR")])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.clearedView && _vm.showOrdersCostPrice
                    ? _c("th", [_vm._v("Себест.")])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.clearedView && _vm.showOrdersCostPrice
                    ? _c("th", [_vm._v("Прибыль")])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.clearedView ? _c("th", [_vm._v("Адрес")]) : _vm._e(),
                  _vm._v(" "),
                  !_vm.clearedView ? _c("th", [_vm._v("Курьер")]) : _vm._e(),
                  _vm._v(" "),
                  _c("th"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  !_vm.clearedView && _vm.ordersSummary.total_price
                    ? _c("tr", { staticClass: "tr-highlighted hide_small" }, [
                        _c("td", { attrs: { colspan: "3" } }),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              (_vm.ordersSummary.total_price &&
                                _vm.ordersSummary.total_price.toLocaleString(
                                  "ru-RU"
                                )) ||
                                0
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              (_vm.ordersSummary.total_salary &&
                                _vm.ordersSummary.total_salary.toLocaleString(
                                  "ru-RU"
                                )) ||
                                0
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              (_vm.ordersSummary.total_post &&
                                _vm.ordersSummary.total_post.toLocaleString(
                                  "ru-RU"
                                )) ||
                                0
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              (_vm.ordersSummary.total_pass &&
                                _vm.ordersSummary.total_pass.toLocaleString(
                                  "ru-RU"
                                )) ||
                                0
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.cashOperate
                          ? _c("td", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    (
                                      (_vm.ordersSummary.total_price -
                                        _vm.ordersSummary.total_salary || 0) -
                                      _vm.prePaidSum
                                    ).toLocaleString("ru-RU")
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showOrdersCostPrice
                          ? _c("td", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    (_vm.ordersSummary.price_in_eur &&
                                      _vm.ordersSummary.price_in_eur.toLocaleString(
                                        "ru-RU"
                                      )) ||
                                      0
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showOrdersCostPrice
                          ? _c("td", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    (_vm.ordersSummary.total_cost &&
                                      _vm.ordersSummary.total_cost.toLocaleString(
                                        "ru-RU"
                                      )) ||
                                      0
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showOrdersCostPrice
                          ? _c("td", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    (
                                      _vm.ordersSummary.price_in_eur -
                                      _vm.ordersSummary.total_cost
                                    ).toLocaleString("ru-RU")
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "10" } }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.orders, function (order) {
                    return (_vm.statuses || [3, 11]).includes(order.status)
                      ? _c(
                          "tr",
                          {
                            key: order.id,
                            class: {
                              inEncashment:
                                _vm.encashmentDate &&
                                _vm.isBefore(
                                  order.report_date,
                                  _vm.encashmentDate
                                ),
                            },
                          },
                          [
                            _c(
                              "td",
                              [
                                _vm.clearedView
                                  ? [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(order.id) +
                                          "\n          "
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: `/orders/edit/${order.id}`,
                                          },
                                        },
                                        [_vm._v(_vm._s(order.id))]
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.moment(
                                              order.report_date,
                                              "DD.MM.YYYY HH:mm:ss"
                                            )
                                          )
                                        ),
                                      ]),
                                    ],
                              ],
                              2
                            ),
                            _vm._v(" "),
                            !_vm.clearedView
                              ? _c("td", [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$AllProjects[order.site_id].name
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        (_vm.$AllCities[order.city_id] &&
                                          _vm.$AllCities[order.city_id].name) ||
                                          order.city_id
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.moment(
                                          order.delivery_date,
                                          "DD.MM.YYYY HH:mm"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.printPostTrack(order)
                                      ),
                                    },
                                  }),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.clearedView
                              ? _c("td", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.printDrugs(order.details)
                                    ),
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "hide_small" },
                              [
                                order.pay_method === 3
                                  ? [
                                      _c("p", [_vm._v(_vm._s(order.price))]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._m(1, true),
                                        _vm._v(
                                          " " + _vm._s(order.no_cash_price)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      order.no_cash_price < order.price
                                        ? _c("p", [
                                            _vm._v(
                                              "₽ " +
                                                _vm._s(
                                                  order.price -
                                                    order.no_cash_price
                                                )
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  : [_c("p", [_vm._v(_vm._s(order.price))])],
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "hide_small" }, [
                              _vm._v(_vm._s(order.salary)),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "hide_small" }, [
                              _vm._v(_vm._s(order.post_expenses)),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "hide_small" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    order.price -
                                      (+order.salary || 0) -
                                      (+order.post_expenses || 0)
                                  ) +
                                  "\n        "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.cashOperate
                              ? _c("td", { staticClass: "hide_small" }, [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        order.price -
                                          (+order.salary || 0) -
                                          (order.pay_method === 3
                                            ? +order.no_cash_price
                                            : 0) -
                                          (+order.post_expenses || 0)
                                      ) +
                                      "\n        "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "show_small price_details" },
                              [
                                _c("div", [
                                  _c("p", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          order.price.toLocaleString("ru-RU")
                                        )
                                      ),
                                    ]),
                                    _vm._v(
                                      " -\n              сумма\n            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          (order.salary || 0).toLocaleString(
                                            "ru-RU"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(
                                      "\n              - ЗП\n            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          (
                                            order.post_expenses || 0
                                          ).toLocaleString("ru-RU")
                                        )
                                      ),
                                    ]),
                                    _vm._v(
                                      "\n              - Почтовые р.\n            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          (
                                            order.price -
                                            (+order.salary || 0) -
                                            (+order.post_expenses || 0) -
                                            (order.pay_method === 3
                                              ? order.no_cash_price
                                              : 0)
                                          ).toLocaleString("ru-RU")
                                        )
                                      ),
                                    ]),
                                    _vm._v(
                                      "\n              - к сдаче\n            "
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.clearedView && _vm.showOrdersCostPrice
                              ? _c("td", [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        (
                                          Math.round(order.price_in_eur * 100) /
                                          100
                                        ).toLocaleString("ru-RU")
                                      ) +
                                      "\n        "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.clearedView && _vm.showOrdersCostPrice
                              ? _c("td", [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        (order.cost_price &&
                                          order.cost_price.toLocaleString(
                                            "ru-RU"
                                          )) ||
                                          0
                                      ) +
                                      "\n        "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.clearedView && _vm.showOrdersCostPrice
                              ? _c("td", [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        (
                                          Math.round(
                                            (order.price_in_eur -
                                              order.cost_price) *
                                              100
                                          ) / 100
                                        ).toLocaleString("ru-RU")
                                      ) +
                                      "\n        "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.clearedView
                              ? _c("td", [
                                  _vm._v(
                                    _vm._s(order.address) + "\n          "
                                  ),
                                  _vm.showComment
                                    ? _c("div", { staticClass: "text-muted" }, [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(order.reject_comment) +
                                            "\n          "
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.clearedView
                              ? _c("td", [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.runnerNames[order.runner_id]) +
                                      "\n        "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("td", [
                              order.pay_method === 3
                                ? _c("span", { staticClass: "fs-14" }, [
                                    _c("i", {
                                      staticClass:
                                        "icon-fa icon-fa-credit-card",
                                    }),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(_vm._s(order.no_cash_price)),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  !_vm.clearedView && _vm.ordersSummary.total_price
                    ? _c("tr", { staticClass: "tr-highlighted hide_small" }, [
                        _c("td", { attrs: { colspan: "3" } }),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              (_vm.ordersSummary.total_price &&
                                _vm.ordersSummary.total_price.toLocaleString(
                                  "ru-RU"
                                )) ||
                                0
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              (_vm.ordersSummary.total_salary &&
                                _vm.ordersSummary.total_salary.toLocaleString(
                                  "ru-RU"
                                )) ||
                                0
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              (_vm.ordersSummary.total_post &&
                                _vm.ordersSummary.total_post.toLocaleString(
                                  "ru-RU"
                                )) ||
                                0
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              (_vm.ordersSummary.total_pass &&
                                _vm.ordersSummary.total_pass.toLocaleString(
                                  "ru-RU"
                                )) ||
                                0
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.cashOperate
                          ? _c("td", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    (
                                      (_vm.ordersSummary.total_price -
                                        _vm.ordersSummary.total_salary || 0) -
                                      _vm.prePaidSum
                                    ).toLocaleString("ru-RU")
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showOrdersCostPrice
                          ? _c("td", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    (_vm.ordersSummary.price_in_eur &&
                                      _vm.ordersSummary.price_in_eur.toLocaleString(
                                        "ru-RU"
                                      )) ||
                                      0
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showOrdersCostPrice
                          ? _c("td", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    (_vm.ordersSummary.total_cost &&
                                      _vm.ordersSummary.total_cost.toLocaleString(
                                        "ru-RU"
                                      )) ||
                                      0
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showOrdersCostPrice
                          ? _c("td", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    (
                                      _vm.ordersSummary.price_in_eur -
                                      _vm.ordersSummary.total_cost
                                    ).toLocaleString("ru-RU")
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", { attrs: { colspan: "10" } }),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", [_vm._v("К сдаче"), _c("br"), _vm._v("общее")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "fs-14" }, [
      _c("i", { staticClass: "icon-fa icon-fa-credit-card" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }